<!--
  mall/src/components/common/goods-unit/index.vue
  GoodsUnit goods-unit
-->

<template>
  <div :style="{ width: goodsStyle === 1 ? '100%' : 'auto' }" style="height: 100%; overflow: hidden">
    <!--分类列表页在用的样式-->
    <div v-if="goodsStyle === 1" class="goods-item flex-row col-center mt5"
      v-on:click.stop="$router.push(`/goods-detail?goodsId=${goodsId}`)">
      <img :src="headImage" class="goods-img" />
      <div class="ml8 flex-col row-between" style="height: 85px; width: 100%">
        <div>
          <div class="goods-name">
            <div class="ml4 tag_name">
              <van-tag v-for="tag in tags" :key="tag" color="#f55519" style="
                  margin-right: 5px;
                  font-size: 14px;
                  padding: 0 4px;
                  line-height: normal;
                ">{{ tag }} </van-tag>
              {{ name }}
            </div>
          </div>
          <div class="sale-num mt3">{{ saleCount }}人付款</div>
        </div>
        <div class="flex-row row-between col-center">
          <div class="goods-price budo-line-20">
            <span v-if="visiblePrice === 1">{{ price | money }}</span>
          </div>
          <div v-if="goodsType !== 'TICKET'" class="iconfont icon-gouwuche goods-buy-btn" @click.stop="add_cart_dgss()">
          </div>
        </div>
      </div>
    </div>

    <!--详情页在用的样式-->
    <div v-else-if="goodsStyle === 2" style="margin-right: 32px"
      v-on:click.stop="$router.push(`/goods-detail?goodsId=${goodsId}`)">
      <img :src="headImage" alt="" style="width: 92px; height: 92px" />
      <div style="
          font-size: 13px;
          font-weight: 500;
          color: #011825;
          height: 51px;
          overflow: hidden;
        ">
        {{ name }}
      </div>
      <div class="mt8 flex-row row-between col-center budo-51">
        <div style="font-size: 15px; font-weight: bold; color: #ff423f">
          {{ price | money }}
        </div>
        <div v-if="goodsType !== 'TICKET'" class="iconfont icon-gouwuche goods-buy-btn" @click.stop="addCart()"></div>
      </div>
    </div>

    <!--首页在用的样式-->
    <div v-else-if="goodsStyle === 3" v-on:click.stop="$router.push(`/goods-detail?goodsId=${goodsId}`)">
      <van-image :src="headImage" height="100%" width="100%"></van-image>
      <p style="
          width: 100%;
          max-height: 34px;
          overflow: hidden;
          line-height: 17px;
        ">
        {{ name }}
      </p>
      <div class="mt8 flex-row row-between col-center budo-68" flex="box:last">
        <div class="flex-row col-center" flex="cross:center" style="font-size: 0">
          <img alt="" class="price-icon"
            src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
            style="margin-top: -4px" />
          <span style="font-size: 18px; color: #fc3f3f">{{
            price | money
          }}</span>
        </div>
        <div style="
            width: 22px;
            height: 22px;
            background: #fc3f3f;
            border-radius: 50%;
            color: white;
            text-align: center;
            line-height: 22px;
          ">
          <div class="iconfont icon-gouwuche" @click.stop="addCart()"></div>
        </div>
      </div>
      <div style="font-size: 12px; color: #939393">已售 {{ saleCount }}</div>
    </div>

    <!-- 首页-今日热卖-明日预告-->
    <div v-else-if="goodsStyle === 4" class="flex-row"
      v-on:click.stop="$router.push(`/goods-detail?goodsId=${goodsId}`)">
      <van-image :src="headImage ||
        'https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/flf2dac3qmz9zw2ixui6enls.png'
        " class="goods-img" fit="cover" lazy-load />
      <div class="ml10 flex-col row-between">
        <div>
          <div style="
              font-size: 15px;
              font-weight: 500;
              color: #333333;
              width: 100%;
            ">
            {{ name }}
          </div>
          <div class="mt5" style="
              width: 41px;
              height: 15px;
              background: #ff965c;
              border-radius: 3px;
              font-size: 10px;
              color: white;
              text-align: center;
              line-height: 15px;
            ">
            活动中
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; width: 220px">
          <div class="flex-row col-end">
            <div class="flex-row col-center" style="font-size: 18px; font-weight: bold; color: #fc3f3f">
              <img class="price-icon"
                src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
              {{ price | money }}
            </div>
            <div class="ml4" style="
                font-size: 12px;
                font-weight: 500;
                text-decoration: line-through;
                color: #9a9a9b;
                margin-bottom: 3px;
              ">
              ￥{{ originalPrice | money }}
            </div>
          </div>
          <div class="flex-row col-center row-center" style="
              width: 68px;
              height: 21px;
              background: #fc3f3f;
              border-radius: 10px;
              color: white;
            " @click.stop="addCart()">
            <span style="font-size: 12px">立即兑换</span>
            <van-icon name="arrow" style="font-size: 12px" />
          </div>
        </div>
      </div>
    </div>

    <!-- 首页-底部促销-->
    <div v-else-if="goodsStyle === 5" v-on:click.stop="$router.push(`/goods-detail?goodsId=${goodsId}`)"
      style="text-align: center">
      <van-image :src="headImage" height="135" width="100%"></van-image>

      <div class="flex-row col-center">
        <div class="ml4" style="
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 13px;
            font-weight: 500;
            text-align: left;
          ">
          <van-tag v-for="tag in tags" :key="tag" color="#f55519" style="
              margin-right: 5px;
              font-size: 14px;
              padding: 0 4px;
              line-height: normal;
            ">{{ tag }}
          </van-tag>
          {{ name }}
        </div>
      </div>
      <div class="flex-row col-center" style="margin-top: 10px; justify-content: space-between">
        <div style="display: flex; align-items: center">
          <img alt="" class="price-icon"
            src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png" />
          <span style="font-size: 18px; color: #fc3f3f">
            {{ price | money }}
          </span>
        </div>
        <i v-if="goodsType !== 'TICKET'" class="van-icon van-icon-cart-o" style="color: #fc3f3f"
          @click.stop="addCart()"></i>
      </div>
    </div>

    <!-- 生日汇-蛋糕推荐-->
    <div v-else-if="goodsStyle === 6">
      <router-link :to="{ path: 'goods-detail', query: { goodsId: goodsId } }">
        <div>
          <img :src="headImage" alt="" style="width: 73px; height: 73px" />
          <div class="mt2" style="font-size: 12px; color: #f23a3a; text-align: center">
            {{ price | money }}
          </div>
        </div>
      </router-link>
    </div>

    <!-- 生日汇-蛋糕推荐-->
    <div v-else-if="goodsStyle === 7" class="y-item">
      <router-link :to="{ path: 'goods-detail', query: { goodsId: goodsId } }">
        <img :src="headImage" alt="" style="width: 100px; height: 105px" />
        <div>
          <div style="
              width: 100px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 13px;
              font-weight: 500;
            ">
            {{ name }}
          </div>
        </div>
        <div style="margin-top: 10px">
          <span style="font-size: 18px; color: #fc3f3f">{{
            price | money
          }}</span>
          <span style="
              font-size: 12px;
              font-weight: 500;
              text-decoration: line-through;
              color: #999999;
            ">{{ originalPrice | money(true) }}</span>
        </div>
      </router-link>
    </div>

    <div v-else-if="goodsStyle === 8">秒杀</div>

    <!--专题详情-->
    <div v-if="goodsStyle === 9" class="goods-item flex-row col-center mt5">
      <img :src="headImage" class="goods-img" @click="
        $router.push({
          path: 'goods-detail',
          query: { goodsId: goodsId, topicId: topicId },
        })
        " />
      <div class="ml8 flex-col row-between" style="height: 85px; width: 100%">
        <div>
          <div class="goods-name" @click="
            $router.push({
              path: 'goods-detail',
              query: { goodsId: goodsId, topicId: topicId },
            })
            ">
            <div class="ml4 tag_name">
              <van-tag v-for="tag in tags" :key="tag" color="#f55519" style="
                  margin-right: 5px;
                  font-size: 14px;
                  padding: 0 4px;
                  line-height: normal;
                ">{{ tag }}
              </van-tag>
              {{ name }}
            </div>
          </div>
          <div class="sale-num mt3"></div>
        </div>
        <div class="flex-row" style="margin-right: 10px">
          <div class="goods-price budo-line-240">
            <span v-if="visiblePrice === 1">{{ price | money }}</span>&nbsp;
          </div>
          <div class="flex-row col-center row-center" style="
              width: 84px;
              height: 21px;
              background: #fc3f3f;
              border-radius: 10px;
              color: white;
              right: 30px;
              position: absolute;
            ">
            <span style="font-size: 12px" @click="onBuyClicked_5">立即兑换</span>
            <van-icon class="ml2" name="arrow" style="font-size: 12px" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="goodsStyle === 11" class="topic_multiple budo-258">
      <van-card :thumb="headImage" @click="
        $router.push({ path: 'goods-detail', query: { goodsId: goodsId } })
        ">
        <template #title>
          <div class="van-card__title">
            {{ name }}
          </div>
        </template>
        <template #tags>
          <van-tag v-for="tag in tags" :key="tag" color="#ffe5dc" size="large" style="
              margin-right: 5px;
              font-size: 14px;
              padding: 1px;
              line-height: normal;
            " text-color="#ff4200">{{ tag }}
          </van-tag>
        </template>
        <template v-if="visibleBuyButton === 1" #footer>
          <div></div>
          <van-button color="linear-gradient(to right, #ff6034, #ee0a24)" round size="small" type="danger"
            @click="onBuyClicked_5">
            <i class="van-icon van-icon-cart-o"></i>
            立即兑换
          </van-button>
        </template>
      </van-card>
    </div>

    <div v-else>
      <!-- else #284 -->
    </div>

    <goods-spec ref="spec" :cate-code="cateCode" :goods-id="goodsId" :head-image="headImage" :name="name" :price="price"
      :sale-count="saleCount" :spec="spec" :spec-visible="specVisible"></goods-spec>
  </div>
</template>

<script>
import GoodsSpec from "@/components/common/goods-spec";
import { mall_util_order_buy_goods } from "@/util/orders";

/* 废弃这个组件  用goods-list-block组件 */
export default {
  name: "goods-unit",
  components: { GoodsSpec },

  data() {
    return {
      specVisible: false,
      sku: {},
      goods: {
        picture: this.headImage,
      },
    };
  },

  props: {
    name: { type: String },
    price: { type: Number },
    originalPrice: { type: Number },
    saleCount: { type: Number },
    goodsId: { type: Number },
    headImage: { type: String },
    spec: { type: String },
    detail: { type: Object },
    goodsStyle: { type: Number, default: 1 },
    cateCode: { type: String, require: true, default: "0001" },
    tags: { type: Array },
    topicId: { type: Number, default: 0 },
    visiblePrice: { type: Number, default: 1 },
    visibleBuyButton: { type: Number, default: 1 },
    goodsType: { type: String },
    supplierId: { type: Number },
  },

  methods: {
    onAddCartClicked(e) {
      const goodsInfo = e.selectedSkuComb;
      mall_util_order_buy_goods(
        e.goodsId,
        e.selectedNum,
        true,
        goodsInfo.spec,
        goodsInfo.price
      );
      this.specVisible = false;
    },

    onBuyClicked_5() {
      if (this.visibleBuyButton === 0) {
        this.$router.push({
          path: "goods-detail",
          query: {
            goodsId: this.goodsId.toString(),
            topicId: this.topicId.toString(),
          },
        });
        return;
      }

      if (this.spec) {
        this.specVisible = true;
        this.$refs.spec.initSpecInfo();
      } else {
        mall_util_order_buy_goods(
          this.goodsId,
          1,
          false,
          this.spec,
          this.price,
          this.topicId
        );
      }
    },

    add_cart_dgss() {
      console.log("#353 add_cart_dgss", this.supplierId);
      if (321 != this.supplierId) {
        // 蛋糕叔叔 不让用购物车
        this.addCart();
        return;
      }

      if (this.spec) {
        this.specVisible = true;
        this.$refs.spec.initSpecInfo(false);
      } else {
        mall_util_order_buy_goods(this.goodsId, 1, true, this.spec, this.price);
      }
    },

    addCart() {
      if (this.spec) {
        this.specVisible = true;
        this.$refs.spec.initSpecInfo();
      } else {
        mall_util_order_buy_goods(this.goodsId, 1, true, this.spec, this.price);
      }
    },

    getSpList(arr) {
      if (arr.length < 2) return arr[0] || [];
      return [].reduce.call(arr, function (col, set) {
        let res = [];
        col.forEach((c) => {
          set.forEach((s) => {
            let t = [].concat(Array.isArray(c) ? c : [c]);
            t.push(s);
            res.push(t);
          });
        });
        return res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";

.tag_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 13px;
  font-weight: 500;
}

.topic_multiple {
  .van-card {
    margin-top: 8px;
    border-radius: 10px;

    .van-card__title {
      font-size: 16px;
    }

    .van-card__desc {
      margin: 10px 0;
      color: #808080;
    }

    .target {
      color: #ff4200;
      background: #ffe5dc;
      padding: 5px 7px;
    }

    .van-card__footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 88px;
    }

    .price-icon {
      width: 18px;
      height: 18px;
      margin-right: 1px;
    }

    .van-button--small {
      padding: 0 15px;
    }

    .van-icon-cart-o {
      font-size: 14px;
      float: left;
      margin-right: 5px;
    }
  }
}
</style>
